
import { Component, Prop, Vue } from 'bits/vue'

export enum OzBoxColors {
  Primary = 'Primary',
  PrimaryBlur = 'PrimaryBlur',
  PrimaryLight = 'PrimaryLight',
  Secondary = 'Secondary',
  Selection = 'Selection',
  Highlight = 'Highlight',
  Destructive = 'Destructive',
  Pink = 'Pink',
  Green = 'Green',
  Tangerine = 'Tangerine',
  Grape = 'Grape',
  Oceanic = 'Oceanic',
  Grey = 'Grey',
  Scarlet = 'Scarlet',
  PostDefault = 'PostDefault',
  PostRed = 'PostRed',
  PostOrange = 'PostOrange',
  PostGreen = 'PostGreen',
  PostBlue = 'PostBlue',
  PostPurple = 'PostPurple',
  TaskDone = 'TaskDone',
  None = 'None',
}

// Standardizes box colors and shape

@Component({})
export default class OzBox extends Vue {
  $el!: HTMLDivElement

  OzBoxColors = OzBoxColors

  /**
   * Dark mode.
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Color scheme.
   *
   *
   * **Primary** - base page background color
   *
   * - Light mode: white
   * - Dark mode: black
   *
   *
   * **Secondary** - use for section boxes over Primary background
   *
   * - Light mode: light grey
   * - Dark mode: dark grey
   *
   * **Selection** - color of active/selected items
   *
   * - Light mode: grape
   * - Dark mode: canary
   *
   *
   * **Highlight** - color of a highlighted section
   *
   * - Light mode: light canary
   * - Dark mode: dark-ui
   *
   *
   * **Destructive** - color of a highlighted section
   *
   * - Light mode: tangerine
   * - Dark mode: dark-ui
   *
   *
   * **Pink** - color of a highlighted section
   *
   * - Light mode: padlet pink
   * - Dark mode: dark-ui
   *
   *
   * **Green** - color of a highlighted section
   *
   * - Light mode: park
   * - Dark mode: dark-ui
   *
   *
   * **Tangerine** - color of a highlighted section
   *
   * - Light mode: tangerine
   * - Dark mode: dark-ui
   *
   *
   * **Grape** - color of a highlighted section
   *
   * - Light mode: grape
   * - Dark mode: dark-ui
   *
   * **Grey** - color of a disabled section in the delete account page
   *
   * - Light mode: grey-0
   * - Dark mode: grey-850
   *
   * **Oceanic** - color of a highlighted section
   *
   * - Light mode: oceanic
   * - Dark mode: dark-ui
   *
   * **Scarlet** - color of a highlighted section
   *
   * - Light mode: scarlet-0
   * - Dark mode: dark-ui-200
   *
   * **PostDefault** - color of a post attachment/sub-element for a post with color default
   *
   * - Light mode: light-ui-200
   * - Dark mode: dark-ui-200
   *
   * **PostRed** - color of a post attachment/sub-element for a red post
   *
   * - Light mode: scarlet-200
   * - Dark mode: scarlet-800
   *
   * **PostOrange** - color of a post attachment/sub-element for aa orange post
   *
   * - Light mode: canary-200
   * - Dark mode: tangerine-800
   *
   * **PostGreen** - color of a post attachment/sub-element for a green post
   *
   * - Light mode: park-200
   * - Dark mode: park-800
   *
   * **PostBlue** - color of a post attachment/sub-element for a blue post
   *
   * - Light mode: oceanic-200
   * - Dark mode: oceanic-800
   *
   * **PostPurple** - color of a post attachment/sub-element for a purple post
   *
   * - Light mode: grape-200
   * - Dark mode: grape-800
   *
   *
   * **null** - OzBox will just provide the shape.
   *
   */
  @Prop({ required: true }) color!: OzBoxColors | null

  /**
   * Border radius (in pixels).
   *
   *
   * **20** - rounded-2.5xl
   *
   * - Default value
   * - Used in dashboard settings and billing related components.
   *
   *
   * **24** - rounded-3xl
   *
   */
  @Prop({ default: 20, type: Number }) radius!: 0 | 8 | 12 | 16 | 20 | 24
}
